import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AuthBootScreen from './AuthBootScreen';

const GuestRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { status } = useAuth();

  if (status === 'loading') {
    return <AuthBootScreen />;
  }

  if (status === 'authenticated') {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
